<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'SEGMENTS.FILTERS.TITLE' | translate }}
  </span>
</mat-toolbar>

<form *ngIf="filtersForm" class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <input
    class="mt-4 input-legacy"
    formControlName="name"
    name="text"
    placeholder="{{ 'SEGMENTS.FILTERS.NAME' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'SEGMENTS.FILTERS.SITUATION' | translate }}
  </div>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-select formControlName="archived">
      <mat-option [value]="false">
        {{ 'SEGMENTS.FILTERS.ACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="true">
        {{ 'SEGMENTS.FILTERS.INACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'SEGMENTS.FILTERS.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
